import { Map } from 'immutable';

import { getSize } from '../../iterable/getSize';

import { EMPTY } from '../../../constants';

export function shapeListingsForApp({ response, state: source }) {
  let state = source;
  const clear = state.get('page') === 0;
  const total = response.connected_listings;

  if (clear) {
    state = state.set('byId', EMPTY.MAP).set('ids', EMPTY.LIST);
  }

  state = state
    .set('hasMore', getSize(state.get('ids')) + getSize(response.data) < total)
    .set('total', total);

  function reduceListings(result, listing) {
    const { id, thumbnail_url: thumbnailUrl, title } = listing;

    function updateById(byId) {
      return byId.set(id, Map({ id, thumbnailUrl, title }));
    }

    function updateIds(ids) {
      return ids.push(id);
    }

    return result.update('byId', updateById).update('ids', updateIds);
  }

  return response.data.reduce(reduceListings, state);
}
